import { Navigate, Outlet } from 'react-router-dom';
import { useAtomValue } from 'jotai';
import { hasPermissionAtom } from '@/store/authAtoms';

export default function PermissionRoute({ accessString }: Readonly<{ accessString: string }>) {
  const allowed = useAtomValue(hasPermissionAtom(accessString));
  return allowed ? <Outlet /> : <Navigate to="/dashboard" replace />;
}
